<template>
    <div>{{state}}</div>
<!-- INITIAL
ON
OFF
SERVICE
BELOW_SETPOINT
ABOVE_SETPOINT
BELOW_THRESHOLD
ABOVE_THRESHOLD
STANDBY
HEATING
BYPASS
OVERHEATED -->

</template>

<script>
export default {
    props: ["state"],
};
</script>